import { render, staticRenderFns } from "./ClassTabTeachers.vue?vue&type=template&id=59a57ae7&scoped=true&"
import script from "./ClassTabTeachers.vue?vue&type=script&lang=js&"
export * from "./ClassTabTeachers.vue?vue&type=script&lang=js&"
import style0 from "./ClassTabTeachers.vue?vue&type=style&index=0&id=59a57ae7&prod&lang=scss&scoped=true&"
import style1 from "./ClassTabTeachers.vue?vue&type=style&index=1&id=59a57ae7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a57ae7",
  null
  
)

export default component.exports